import axios from "axios";


const supplierBaseUrl = process.env.REACT_APP_SUPPLIER_BACKEND;


export const uploadFileToRFQ = (data, token) => {
  return new Promise(async (resolve, reject) => {
    try {
      let header = {
        Authorization: `Bearer ${JSON.parse(token)}`,
        "Content-Type": "application/json",
      };

      let response = await axios.post(
        `${supplierBaseUrl}/admin/upload-file-to-rfq`,
        data,
        { headers: header }
      );
      return resolve(response.data);
    } catch (err) {
      return reject(err);
    }
  });
};

export const uploadPartSnapShotDataOfferRFQ = async (token, data) => {
  try {
    let header = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      'Content-Type': 'multipart/form-data',
    };

    let response = await axios.post(
      `${supplierBaseUrl}/admin/update-part-snapshot`,
      data,
      { headers: header }
    );
    return response.data;
  } catch (err) {
    return err;
  }
};
export const deletePartSnapShotDataOfferRFQ = async (token, data) => {
  try {
    let header = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      'Content-Type': "application/json",
    };

    let response = await axios.delete(
      `${supplierBaseUrl}/admin/delete-part-snapshot`,
      {
        headers: header,
        data: data,
      }
    );
    return response.data;
  } catch (err) {
    return err.response ? err.response : err;
  }
};
export const globalProjectNameSearchSupplier = async (token, projectName, page) => {
  try {
    let header = {
      Authorization: `Bearer ${JSON.parse(token)}`,
      'Content-Type': "application/json",
    };

    let response = await axios.get(
      `${supplierBaseUrl}/admin/search?projectName=${projectName}&page=${page}`,
      {
        headers: header,
      }
    );
    return response.data;
  } catch (err) {
    return err.response ? err.response : err;
  }
};
